// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import PipProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/pip-product-search-results';
import TranslatedOption from '../../../../shared/components/translated-option';

const PipProductsDropDown = ({list, shouldTranslate = false, ...props}) =>
    <select
        {...props}
    >
        <option value=''/>
        {
            list.map(pipProduct =>
                shouldTranslate ?
                    <TranslatedOption
                        key={pipProduct.id}
                        text={pipProduct.description}
                        value={pipProduct.description}
                    /> :
                        <option
                            key={pipProduct.id}
                            value={pipProduct.description}
                        >
                            {pipProduct.description}
                        </option>
            )
        }
    </select>;

PipProductsDropDown.displayName = 'PipProductsDropDown';
PipProductsDropDown.propTypes = {
    className: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(PipProductSearchResult)).isRequired,
    onChange: PropTypes.func.isRequired,
    shouldTranslate: PropTypes.bool,
    value: PropTypes.string.isRequired
};

export default PipProductsDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/pip-products-drop-down.js